export default {
  p: { x: 416, y: 155 },
  r: 30,
  s: [
    { x: 483, y: 260 },
    { x: 356, y: 260 },
  ],
  b: [
    { x: 400, y: 120 },

    { x: 460, y: 290 },
    { x: 460, y: 322 },
    { x: 460, y: 354 },

    { x: 340, y: 290 },
    { x: 340, y: 322 },
    { x: 340, y: 354 },
  ],
  g: [{ x: 500, y: 650 }],
  h: [
    { x: 483, y: 226 },
    { x: 356, y: 226 },
  ],
};
